var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import createPersistedState from 'vuex-persistedstate';
// 引入模块
import Workspace from './modules/workspace.store';
import MessageCollection from './modules/message-collection.store';
import SystemManage from './modules/system-manage.store';
import CaseManage from './modules/case-manage.store';
import CaseAllot from './modules/case-allot.store';
import CollectionExecution from './modules/collection-execution.store';
Vue.use(Vuex);
var filterList = ['ready', 'layout'];
var store = new Vuex.Store({
    // 子模块
    modules: {
        workspace: Workspace,
        'message-collection': MessageCollection,
        'system-manage': SystemManage,
        'case-manage': CaseManage,
        'case-allot': CaseAllot,
        'collection-execution': CollectionExecution
    },
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
    plugins: [
        // 持久化存储插件
        createPersistedState({
            key: 'vuex',
            reducer: function (state, paths) {
                return __assign(__assign({}, state), { ready: false, layout: 'default' });
            },
            storage: localStorage,
            filter: function (_a) {
                var type = _a.type, payload = _a.payload;
                return !filterList.includes(type);
            },
        }),
    ],
});
export default store;
